module.exports = __webpack_public_path__ + "img/logotype_warex@2x.a39d5d3.png";